var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_-_Copy",
    "data-name": "edit - Copy",
    transform: "translate(-16.19 -18.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13856",
    "data-name": "Path 13856",
    d: "M122.831.98a2.454,2.454,0,0,0-3.471,0l-9.73,9.73a.545.545,0,0,0-.14.24l-1.28,4.62a.545.545,0,0,0,.671.671l4.62-1.28a.545.545,0,0,0,.24-.14l9.73-9.731a2.457,2.457,0,0,0,0-3.471ZM110.818,11.065,118.782,3.1l2.568,2.568-7.964,7.964Zm-.513,1.029,2.052,2.052-2.838.786ZM122.7,4.319l-.578.578-2.569-2.569.579-.578a1.363,1.363,0,0,1,1.928,0l.64.64A1.365,1.365,0,0,1,122.7,4.319Zm0,0",
    transform: "translate(-92 18)",
    fill: "#777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.05e2bed0ab87f1c558aa7961345371e9.svg";
export { ForwardRef as ReactComponent };